// department-switcher

const activeFetches = new Map()

document.addEventListener('DOMContentLoaded', () => {
  setupDeptSwitcher()
})

function setupDeptSwitcher() {
  // console.log('setupDeptSwitcher')
  const departmentSwitchers = document.querySelectorAll('.js-dept-switch-trigger')
  departmentSwitchers.forEach((switcher) => {
    switcher.addEventListener('change', (e) => {
      handleDeptSwitcherChange(e)
    })
  })
}

function handleDeptSwitcherChange(e) {
  const dept = e.target.dataset.dept
  const deptTargets = document.querySelectorAll('.js-dept-switch-target')
  Array.from(deptTargets).forEach((target) => {
    // filter out classes that include the string '-template-'
    const selector = Array.from(target.classList)
      .filter((cls) => !cls.includes('-template-'))
      .map((cls) => `.${cls}`)
      .join('')
    fetchNewDeptContent(dept, selector)
  })
}

window.fetchNewDeptContent = fetchNewDeptContent
async function fetchNewDeptContent(dept, selector) {
  console.log('fetchNewDeptContent', dept, selector)

  const deptTarget = document.querySelector(selector)
  if (!deptTarget) return

  // Abort any existing fetch for this selector
  if (activeFetches.has(selector)) {
    activeFetches.get(selector).abort()
  }

  // Create new AbortController for this fetch
  const abortController = new AbortController()
  activeFetches.set(selector, abortController)

  const pathMap = {
    mens: '/',
    men: '/',
    womens: '/pages/womens',
    women: '/pages/womens',
    kids: '/pages/kids',
  }

  const path = pathMap[dept]
  if (!path) {
    console.error('Invalid department:', dept)
    activeFetches.delete(selector)
    return
  }

  try {
    const response = await fetch(path, { signal: abortController.signal })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const html = await response.text()
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const newSection = doc.querySelector(selector)

    if (newSection) {
      HTMLUpdateUtility.viewTransition(deptTarget, newSection)
    } else {
      // if no new section, remove content of target element
      console.error('New section not found in response')
      deptTarget.innerHTML = ''
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Fetch aborted for:', selector)
    } else {
      console.error('Error fetching department content:', error)
    }
  } finally {
    // Clean up the abort controller from the Map
    if (activeFetches.get(selector) === abortController) {
      activeFetches.delete(selector)
    }
  }
}
